import { StyleSheet, Text, View, Image,Dimensions } from "react-native";
import React from "react";
import { useAppSelector } from "../../../../hooks/reduxHooks";
import OverlayGIF from "./OverlayGIF";
import useFetchImage from "../../../../hooks/useFetchImage";
import { User } from "../../../../store/slices/authSlice";

const DNEBack = () => {
  const user = useAppSelector((s) => s.auth.subUser!);
  const dateNow = new Date();
  const status =
    user &&
    user.card?.fesn_data?.status &&
    user.card?.fesn_data?.status !== "Pending"
      ? new Date(user.card?.expiry) > dateNow
        ? "VALID"
        : "EXPIRED"
      : "PENDING";


      const CardSrc = useFetchImage(
        "/users/profile/card/images/",
        user.card.display_images.back
      );

  return (
    <View style={styles.cardContainer}>
      <Image
        source={{ uri: CardSrc }}
        style={[styles.card, status !== "VALID" && { tintColor: "gray" }]}
        resizeMode="contain"
      />
      {status !== "VALID" && (
        <Image
          source={{ uri: CardSrc }}
          style={[styles.card, { opacity: 0.3, position: "absolute" }]}
          resizeMode="contain"
        />
      )}
      <View style={styles.cardContent}>
<Text style={styles.cardNumber}>
        {user.card?.isic_data?.isic_card_number}
      </Text>
      </View>
      
      {user?.card &&
        user.card?.fesn_data?.status !== "Pending" &&
        new Date(user.card?.expiry) > dateNow && <OverlayGIF />}
    </View>
  );
};

export default DNEBack;
const windowWidth = Dimensions.get("window").width;
const ratio = 1460 / 920;
const cardWidth = windowWidth * 0.95;
const cardHeight = cardWidth * ratio;
const styles = StyleSheet.create({
  cardContainer: {
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
    marginTop: 50,
  },
  card: {
    borderRadius: 20,
    height: cardHeight,
    width: cardWidth,
  },
  cardContent: {
    position: "absolute",
    width: cardHeight,
    height: cardWidth,
    transform: [{ rotate: "270deg" }],
  },

  cardNumber: {
    position: "absolute",
    top: cardWidth * 0.08,
    left: cardHeight * 0.618,
    width: 200,
  },
});
